import { useEffect } from 'react';
import { useLocalStorage } from './useLocalStorage';

const THEME_STORAGE_KEY = 'sutra-theme';

/**
 * Theme management hook
 * Handles theme state, localStorage persistence, and DOM attribute updates
 * @returns {[string, function]} - [theme, toggleTheme]
 */
export function useTheme() {
  const [theme, setTheme] = useLocalStorage(THEME_STORAGE_KEY, 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return [theme, toggleTheme];
}
